import './Tabs.scss'

import { useState } from 'react'

const Tabs = ({ tabs }) => {
    const [currentTab, setCurrentTab] = useState(tabs[0])

    return (
        <div className="container-fluid tabs">
            {tabs.length > 1 && (
                <ul className="d-flex list mb-4">
                    {tabs.map((tab) => (
                        <li className={`col tab flex-center ${tab.name === currentTab?.name ? 'current' : ''}`} onClick={() => setCurrentTab(tab)} key={tab.name}>
                            <span>{tab.label}</span>
                            {!!tab.notification && <span className="notification-dot ml-3"></span>}
                        </li>
                    ))}
                </ul>
            )}

            {currentTab && <div className="row content"><currentTab.Component /></div>}
        </div>
    )
}

export default Tabs